<template>
  <div class="myVip" v-if="loading" v-cloak>
    <nav-bar nav-bar-type="transparent" navBarTitle="我的会员权益"></nav-bar>
    <div class="myVip-t-wrap" :class="[showNavbar ? 'background1': 'background']">
      <div class="myVip-header" >
        <div  class="header-card">
          <div class="header-card-l">
            <div class="header-card-l-t" v-if="!personInfo.defaultUserName && personInfo.userName && personInfo.companyPosition">
              <div class="profile">
                <img :src="avatarImg" />
              </div>
              <div class="info">
                <div class="name  ellipsis-1">{{ personInfo.userName}}</div>
                <div class="position ellipsis-1">{{ personInfo.companyPosition }}</div>
              </div>
            </div>
            <div class="vipsigntip" v-else>
              <div class="tips">VIP尚未签名</div>
              <div class="govipsign" @click="goVipSign"><span class="iconfont iconlujing21"></span>去签名</div>
            </div>
            <div class="header-card-l-b">
              有效期截止至<span>{{ personInfo.vipEndTime | vipEndDate }}</span>
            </div>
          </div>
          <div class="header-card-r">
            <img src="../../assets/img/vip/vip-log.png">
            <div class="btn" @click="goBtnClick">{{btnText}}</div>
          </div>
        </div>
      </div>
      <div class="myVip-right">
        <div class="myVip-right-tab">
          <van-swipe :loop="false" :show-indicators="false" class="my-swipe" :width="wipeWidth" ref="rightSwipe">
            <!--优惠券-->
            <van-swipe-item  @click="changeTab(0)">
              <div class="swipe-item-wrap">
                <div class="my-tab-item">
                  <img src="../../assets/img/vip/right_img01.png" />
                  <div class="title">优惠券礼包</div>
                  <div class="desc">还剩<span>{{ personInfo.availableCouponNum || 0 }}</span>张</div>
                </div>
                <img v-show="currentIndex===0" class="angle" src="../../assets/img/vip/angle.png">
              </div>
            </van-swipe-item>
            <!--专家质询-->
            <van-swipe-item  @click="changeTab(1)"  v-if="personInfo.policyExpertPrivilege">
              <div class="swipe-item-wrap">
                <div class="my-tab-item">
                  <img src="../../assets/img/vip/right_img02.png" />
                  <div class="title">专家咨询</div>
                  <div class="desc" v-if="personInfo.policyExpertLeftTimes>-1">剩余<span>{{ personInfo.policyExpertLeftTimes || 0 }}</span>次</div>
                  <div class="desc" v-if="personInfo.policyExpertLeftTimes===-1">政策答疑解惑</div>
                </div>
                <img v-show="currentIndex===1" class="angle" src="../../assets/img/vip/angle.png">
              </div>
            </van-swipe-item>
            <!--政策小秘书-->
            <van-swipe-item  @click="changeTab(2)" v-if="personInfo.policySecretaryPrivilege">
              <div class="swipe-item-wrap">
                <div class="my-tab-item">
                  <div style="position: relative;display: inherit">
                    <div class="radius" v-if="personInfo.policySecretaryNum"></div>
                    <img src="../../assets/img/vip/right_img03.png" />
                  </div>
                  <div class="title">政策小秘书</div>
                  <div class="desc" v-if="personInfo.policySecretaryNum">新增<span>{{ personInfo.policySecretaryNum }}</span>条</div>
                  <div class="desc" v-if="!personInfo.policySecretaryNum">每日检测提醒</div>
                </div>
                <img v-show="currentIndex===2" class="angle" src="../../assets/img/vip/angle.png">
              </div>
            </van-swipe-item>
            <!--查看特权-->
            <van-swipe-item  @click="changeTab(3)" ref="rightDesc">
              <div class="swipe-item-wrap">
                <div class="my-tab-item">
                  <img src="../../assets/img/vip/right_img04.png" />
                  <div class="title">查看特权</div>
                  <div class="desc">政策查看不限</div>
                </div>
                <img v-show="currentIndex===3" class="angle" src="../../assets/img/vip/angle.png">
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
    <div class="right-content">
      <transition-group :name="direction" class="slide-content">
          <!--查看优惠券 -->
          <coupon-list   :key="0" v-if="currentIndex===0"></coupon-list>
          <!--专家咨询-->
          <expert-consult v-if="currentIndex===1" :key="1"></expert-consult>
          <!--政策小秘书-->
          <policy-secretary v-if="currentIndex===2" :key="2" @changeChecked="changeChecked">
          </policy-secretary>
          <!--查看特权-->
          <permission v-if="currentIndex===3" :key="3"></permission>
      </transition-group>
    </div>
  </div>
</template>

<script>
import permission from './components/permission'
import CouponList from './components/RightCoupon'
import ExpertConsult from'./components/ExpertConsult'
import PolicySecretary from './components/PolicySecretary'
import { mapGetters, mapMutations } from 'vuex';
import { reqGetMyPageInfo, reqUpdateInfo } from '../../api';
import Toast from 'vant/es/toast';
import avatarDefault from "../../assets/img/member/profile.png"
import { getUrlParams, isIOS, isMini } from '@/utils'
// import WX from 'weixin-js-sdk'


export default {
  name: 'myVip',
  components: {
    permission,
    CouponList,
    ExpertConsult,
    PolicySecretary,
  },
  computed: {
    avatarImg: {
      get() {
        return this.personInfo.avatar ? this.personInfo.avatar : avatarDefault
      },
      set() {}
    },
    ...mapGetters(['person','policySecretaryNum']),
    'person.policySecretaryNum':{
      get() {
        return this.policySecretaryNum
      },
      set() {}
    }
  },
  data() {
    return {
      loading: false,
      wipeWidth: 113,
      currentIndex: 0,
      personInfo: {
        policySecretaryNum: 0,
        policyExpertLeftTimes: 0,
        availableCouponNum: 0,
        policySecretary: 0,
        policyExpertOnline: 0,
      },
      policyList: [],
      direction:'left',
      showNavbar: false, // 是否显示navbar
      btnText: '续费' // 按钮文案
    }
  },
  created() {
    this.showNavbar = Number(localStorage.getItem('clearNav')) === 1 ? true : false
    this.s = localStorage.getItem('s') || getUrlParams('s') || 'H5'
    if(isMini() || this.s == 'BSM') {
      if(isIOS()){
      this.btnText = '下载老板云APP'
      }
    }
    this.initData()
  },
  mounted() {
    if(this.$route.query && this.$route.query.index){
      this.currentIndex = Number(this.$route.query.index) || 0
    }
  },
  watch: {
    loading(){
      this.$nextTick(()=>{
        // 默认选择查看特权，tab滑动到相应位置
        if(this.currentIndex === 3){
          this.$refs['rightDesc'].$el.click()
        }
      })
    }
  },
  filters: {
    vipEndDate: function (value) {
      return value.substr(0,16)
    }
  },
  methods: {
    ...mapMutations({
      'setPolicySecretary': 'SET_POLICY_SECRETARY',
      'setUserInfo':  'SET_LOGIN_INFO'
    }),
    goVipSign(){
      this.$router.push({path:'/vipsign'})
    },
    // 
    goBtnClick(){
      if(this.s == 'BSM' && isIOS()){
        this.WX.miniProgram.navigateTo(
        {url: '/pages/download/index'})
      } else{
        this.continueVip()
      }
    },
    initData(){
      let params = {
        channel: 3,
        token: localStorage.getItem('token')
      }
      reqGetMyPageInfo(params).then(res=>{
        if(res.ok) {
          Object.assign(this.personInfo, res.data)
          this.loading = true
          // 设置政策消息提醒
          this.setUserInfo(res.data)
        }else {
          // 处理各种code码错误情况和登录过期等问题
          if(res.code=== '000003' || res.code=== '000002') {
            if(localStorage.getItem('s') === 'BS') {
              this.$router.push('/home')
            } else {
              this.$router.push('/login')
            }
          } else {
            Toast(res.msg)
          }
        }
      })
    },
    // 切换tab
    changeTab(index){
      if(this.currentIndex < index) {
        this.direction='right'
      }else{
        this.direction='left'
      }
      this.currentIndex = index
      if(index>1){
        this.$refs.rightSwipe.next();
      }
      if(index<2){
        this.$refs.rightSwipe.prev()
      }
      if(this.currentIndex===2){
        this.person.policySecretaryNum = 0
      }
    },
    // 否开启政策小秘书
    changeChecked(val) {
      // 更新用户信息
      reqUpdateInfo({'policySecretary': +val}).then((res)=>{
        if(res.ok){
          //  更新赠策小秘书
          this.setPolicySecretary(+val)
        } else {
          Toast('小秘书服务开启失败')
        }
      })
    },
    // 续费
    continueVip(){
      // 续费埋点
      // eslint-disable-next-line
      sensors.track('renewClick', {
        page_positon: '我的'
      })
      this.$router.push({path:'/vip/vipjoin', query: {vipLevel: 1}})
    },
  }
};
</script>

<style lang="less" scoped>
.myVip {
  width: 100%;
  .myVip-t-wrap {
    width: 100%;
    position: relative;
  }
  .myVip-t-wrap.background{
    height: 269px;
    background: linear-gradient(315deg, rgba(47, 54, 67, 1) 0%, rgba(67, 71, 81, 1) 100%);
  }
  .myVip-t-wrap.background1{
    height: 338px;
    padding-top: 69px;
    background:linear-gradient(315deg,rgba(47,54,67,1) 0%,rgba(67,71,81,1) 100%);  }
  .right-content {
    padding: 20px 0;
  }
  .myVip-header {
    width: 100%;
    height: 169px;
    padding: 20px 16px;
    .header-card {
      width: 343px;
      height: 130px;
      background: url('../../assets/img/vip/myvip_bg.png') top no-repeat;
      background-size: cover;
      padding: 22px 16px;
      display: flex;
      justify-content: space-around;
      .header-card-l {
        flex: 1;
        height: 100%;
        .header-card-l-t {
          display: flex;
          align-items: center;
        }
        .vipsigntip{
          display: flex;
          align-items: center;
          font-size: 20px;
          font-weight: bold;
          padding: 10px 0 ;
          color: #333;
          .govipsign{
            color: #7C561E;
            font-size: 12px;
            margin-left: 20px;
            font-weight: normal;
            .iconfont{
              font-size: 12px;
              margin-right: 3px;
            }
          }
        }
        .header-card-l-b {
          font-size:12px;
          font-weight:400;
          color:@darkBlack;
          line-height:12px;
          margin-top: 20px;
        }
        .profile {
          margin-left: 3px;
          width: 50px;
          height: 50px;
          box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
          border:3px solid rgba(255,255,255,1);
          border-radius: 50%;
          overflow-x: hidden;
          > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .info {
          margin-left:13px;
          max-width: 150px;
          background: none;
          .name {
            font-size:22px;
            font-weight:600;
            color:rgba(51,51,51,1);
            height:32px;
            line-height: 32px;
          }
          .position {
            font-size:12px;
            font-weight:400;
            color:@darkBlack;;
            line-height:16px;
            height: 16px;
          }
        }
      }
      .header-card-r {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        >img {
          height: 12px;
          width: 69px;
        }
        .btn {
          width: 100%;
          padding: 0 5px;
          height: 30px;
          line-height: 30px;
          background:rgba(67,71,81,1);
          border-radius:16px;
          color: #D9B57B;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
  .myVip-right {
    /deep/ .van-swipe-item {
      width: 100px;
      height: 100px;
      font-size: 20px;
      line-height: 150px;
      text-align: center;
    }
    /deep/ .van-swipe-item:first-child {
      /*margin-left: 2px;*/
    }
    /deep/ .van-swipe-item:last-child {
      /*margin-right: 16px;*/
    }
    /deep/ .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
      border-bottom: 0;
    }
    /deep/ .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
      border-width: 0;
    }
    /deep/ .van-tabs--line .van-tabs__wrap {
      height: auto;
    }
    /deep/ .van-tabs__line {
      display: none;
    }
    /deep/ .van-tabs__nav--line {
      padding-bottom: 0;
      margin-bottom: 20px;
    }
    .angle {
      width: 26px;
      height: auto;
      position: absolute;
      bottom: -8px;
      left: 37px;
    }
    .myVip-right-tab {
      padding: 0 0 0 16px;
      .my-swipe {
        padding-bottom: 10px;
      }
    }
    .swipe-item-wrap {
      height: 100%;
      position: relative;
      .my-tab-item {
        height: 100%;
        width: 100%;
        background: #434751;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 4px 4px 0px 0px;
        img {
          width: 30px;
          height: 30px;
          margin-top: 17px;
          position: relative;
        }
        .title {
          height:12px;
          font-size:13px;
          font-weight:600;
          color:rgba(255,255,255,1);
          line-height:12px;
          margin-top:10px;
        }
        .radius {
          position: absolute;
          width:10px;
          height:10px;
          background:rgba(250,81,81,1);
          border:1px solid rgba(255,255,255,1);
          left: 25px;
          top:12px;
          border-radius: 50%;
        }
        .desc {
          height:12px;
          font-size:11px;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:12px;
          margin-top: 8px;
          > span{
            display: inline-block;
            color: @yellow;
            padding: 0 5px;
          }
        }

      }
    }
    .swipe-item-wrap:first-child {
    }
    .swipe-item-wrap:last-child {
      margin-right: 10px;
    }
  }
  .myVip-right .rightCoupon /deep/ .van-tabs__nav {
    background: none;
  }
  .myVip-right .rightCoupon /deep/ .van-tabs__line {
    display: block;
  }
  .myVip-right .rightCoupon /deep/ .van-tabs__nav--line
  {
    padding-bottom: 17px;
    margin-bottom: 9px;
  }
}
/*.slide-content{*/
  /*position: absolute;*/
  /*width: 100%;*/
  /*transform:  translateX(0);*/
  /*transition: all 0.1s linear;*/
/*}*/
/*.left-enter-active{*/
  /*transition:all .5s linear;*/
/*}*/
/*.left-leave-active{*/
  /*transition:all .1s linear;*/
/*}*/
/*.right-enter-active{*/
  /*transition:all .5s linear;*/
/*}*/
/*.right-leave-active{*/
  /*transition:all .1s linear;*/
/*}*/
/*.left-enter{*/
  /*transform: translateX(-100%);*/
  /*opacity: 0;*/
/*}*/
/*.left-leave-to{*/
  /*transform: translateX(110%);*/
  /*opacity: 0;*/
/*}*/
/*.right-enter{*/
  /*transform: translateX(100%);*/
  /*opacity: 0;*/
/*}*/
/*.right-leave-to{*/
  /*transform: translateX(-110%);*/
  /*opacity: 0;*/
/*}*/
  [v-cloak]{
    display: none!important;
  }
</style>
